import React from 'react'
import { CookiesProvider } from 'react-cookie'
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import './css/App.css';
import 'react-tooltip/dist/react-tooltip.css';

import Travels from './components/Travels/Travels';

const App = () => {
    return (
        <CookiesProvider>
            <main className='main' style={{ backgroundColor: 'var(--theme-second-color-bg)' }}>
                <div className='container'>
                    <Travels external={true} />
                </div>
            </main>
        </CookiesProvider>
    );
}

export default App;